const colors = {
    backgroundColor: "#070E10",

    surfaceColor: "#181F22",
    surfaceBorderColorDefault: "#4D4F5B",
    surfaceBorderColor: "#2C3C48",
    surfaceBorderColorMono: '#23292E',

    error: "#FF4E53",
    
    primaryColor50: "#aadbdb",
    primaryColor100: "#86ECEC",
    primaryColor200: "#3BCFCE",
    primaryColor300: "#55b7b7",
    primaryColor400: "#2ba5a5",
    primaryColor500: "#13B4AC",
    primaryColor600: "#007b7b",
    primaryColor700: "#006262",
    primaryColor800: "#004A4A",
    primaryColor900: "#004a4a",

    mono0: "#F9FAFB",
    mono100: "#E0E0E0",
    mono200: "#D7DEE6",
    mono300: "#A7B5C8",
    mono400: "#8896A9",
    mono500: "#6D7887",
    mono600: "#515A67",
    mono700: "#343B45",
    mono800: "#23292F",
    mono900: "#0B0F10",

    white: "#FFFFFF",
    black: "#000000",

    secondaryColor: "#699CAE",
    secondaryColor50: "#A9D3D3",
    secondaryColor100: "#8AB6B6",
    secondaryColor200: "#6DA4A4",
    secondaryColor300: "#509191",
    secondaryColor400: "#357474",
    secondaryColor500: "#699CAE",
    secondaryColor600: "#175A73",
    secondaryColor700: "#122831",
    secondaryColor800: "#111D22",
    secondaryColor900: "#071A21",
    accentColor500: "#D3D395",

    ctaDarkMode: "#0F1A1E",
    protectionColor500: "#3BC4FF",
    recoveryColor500: "#56FFD2",


    surfaceColor500: '#0B2A31',
    surfaceColor600: "#111D22",
    surfaceColor700: "#071A21",
    surfaceColor800: "#0D1920"
}

export default colors